import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import { useThemeContext } from '../../styles/themes/themes.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["color", "children", "size"];
var WIDTH_MAP = {
  sm: 200,
  md: 320,
  lg: 640
};
var HEIGHT_MAP = {
  sm: 112,
  md: 200,
  lg: 360
};

var IllustrationBase = function IllustrationBase(props) {
  var _useThemeContext = useThemeContext(),
      CTAColors = _useThemeContext.CTAColors;

  var primary = CTAColors.primary;

  var _props$color = props.color,
      color = _props$color === void 0 ? primary : _props$color,
      children = props.children,
      size = props.size,
      rest = _objectWithoutProperties(props, _excluded);

  var width = size ? WIDTH_MAP[size] : void 0;
  var height = size ? HEIGHT_MAP[size] : void 0;
  return /*#__PURE__*/jsx("svg", _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: "false",
    height: height,
    width: width,
    viewBox: "0 0 320 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {}, {
    children: children(color)
  }));
};

IllustrationBase.propTypes = {
  "children": _PropTypes.func.isRequired,
  "color": _PropTypes.string,
  "size": _PropTypes.oneOf(["lg", "md", "sm"])
};
IllustrationBase.displayName = "IllustrationBase";

export { IllustrationBase };
